import {UserStatus} from '../../enums/user-status';

export interface OnboardingStatusDictRecord {
    label: string;
    status: UserStatus;
    styleClass: string;
}

export const ONBOARDING_STATUS_NONE: UserStatus = null;

export const ONBOARDING_STATUS_DICT: Record<UserStatus, OnboardingStatusDictRecord> = {
    [ONBOARDING_STATUS_NONE]: {
        label:      'enums.onboarding-status.none',
        status:     ONBOARDING_STATUS_NONE,
        styleClass: ''
    },
    [UserStatus.PENDING]:     {
        label:      'enums.onboarding-status.pending',
        status:     UserStatus.PENDING,
        styleClass: '-onboarding-status-pending'
    },
    [UserStatus.APPROVED]:    {
        label:      'enums.onboarding-status.approved',
        status:     UserStatus.APPROVED,
        styleClass: '-onboarding-status-approved'
    },
    [UserStatus.REJECTED]:    {
        label:      'enums.onboarding-status.rejected',
        status:     UserStatus.REJECTED,
        styleClass: '-onboarding-status-rejected'
    }
};
